export const utm_medium_online = 'online'
export const utm_medium_breach = 'breach'

export interface SSWQueryString extends SSWTransaction {
    // Click origin is basically infered from the original utm_medium that is on the subscribe now/packages buttons
    clickOrigin: typeof utm_medium_online | typeof utm_medium_breach
}

export interface SSWTransaction {
    transactionId: number
    transactionTotal: number
    transactionTax: number
    productSku: string
    productName: string
}
